<template>
  <v-app id="public_app">
    <div class="page section section-shaped section-lg">
      <v-container style="height:100vh;" fluid fill-height>
        <v-row justify="center" align="center">
          <v-col lg="4" xs="12" md="6" sm="12" style="margin: 0 auto">
            <v-card class="elevation-6">
              <div style="padding: 15px;border-bottom-left-radius: 0px;border-bottom-right-radius: 0px;text-align: center;position: relative">
                <img src="../../../assets/kanglasha.png" style="height: 100px;width:90px;background: white">
                <h2 class="font-weight-light text-md-center text-lg-center form-title" style="margin-top: 20px">Forget Password</h2>
                <h2 class="font-weight-regular text-md-center text-lg-center body-1">Please fill in all the details</h2>
              </div>
              <v-card-text>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-text-field dense outlined required
                                :rules="rules.emailRules" v-model="user.email" prepend-inner-icon="mdi-account-circle" name="login" label="Email" type="email"></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions style="padding: 0px;width: 100%">
                <v-container>
                  <v-row>
                    <v-col>
                      <v-btn block :loading="submit" :disabled="submit" @click="validateForm" color="success">Send Security Code
                        <template v-slot:loader>
                                            <span class="custom-loader">
                                              <v-icon light>mdi-cached</v-icon>
                                            </span>
                        </template>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </v-app>
</template>

<script>
  import {mapState,mapMutations} from 'vuex'
  import axios from 'axios'
  export default {
    data(){
      return{
        submit:false,
        valid:true,
        user:{
          email:"",
        },
        rules: {
          emailRules: [
            v => !!v || 'User email is required',
          ],
        }
      }
    },
    methods:{
      sendLink(){
        this.submit=true;
        this.$Progress.start();
        this.$http.post('/api/user/auth/security/code',this.user,{params:{'application':'grievance'}})
          .then(response => {
            this.submit=false;
            console.log(response.data);
            if(response.data.status==="Success"){
              this.$Progress.finish();
              this.$router.push({name:'ResetPassword',params:{email:this.user.email}})
            }else{
              this.$dialog.notify.error(this.response.message, {
                position: 'top-right',
                timeout: 5000
              })
              this.$Progress.fail();
            }
          })
          .catch(e => {
            this.submit=false;
            this.$Progress.fail()
            let response=e.response.data
            this.$dialog.notify.error(response.message, {
              position: 'top-right',
              timeout: 5000
            })
          })

      },
      validateForm(){
        if(this.$refs.form.validate()){
          this.sendLink();
        }
      },

    }

  }
</script>
<style>
</style>
